import { toast } from "react-toastify";
import api from "../../api/api";
import { TransferDirection } from "../../types";
import { ACH_TRANSFER } from "../queryKeys";

/*
SERVICE
This is the service for reporting. Since these are not as much shareable hooks and more one-time calls, we can just use a class here.
*/
class TransfersService {
  async createACHTransfer({
    amount,
    direction,
    externalAccountId,
  }: {
    amount: string;
    direction: TransferDirection;
    externalAccountId: number;
  }) {
    try {
      const response = await api.post(ACH_TRANSFER, {
        amount,
        direction,
        external_account: externalAccountId,
      });
      return response;
    } catch (error) {
      toast.error("Error creating transfer. Please try again.");
    }
  }

  async sendVerificationCode(transferId: number) {
    try {
      const response = await api.post(
        `${ACH_TRANSFER}${transferId}/send_2factor_code/`
      );
      return response;
    } catch (error) {
      toast.dismiss();
      toast.error("Error sending verification code. Please try again.");
    }
  }

  async confirmVerificationCode(transferId: number, code: string) {
    try {
      const response = await api.post(
        `${ACH_TRANSFER}${transferId}/verify_2factor_code/`,
        { code }
      );
      return response;
    } catch (error) {
      toast.dismiss();
      toast.error("Error confirming verification code. Please try again.");
    }
  }
}

export default new TransfersService();
